import React, { Component } from 'react';
import { Container, List, Grid, Button, Form, Icon } from "semantic-ui-react"
import moment from 'moment'
import Select from 'react-select';
import {notify} from 'react-notify-toast';
import { translate } from 'react-i18next';

import API from '../utils/API'
import { days, monthsSmall, years, countries, sexes } from '../constants'

import { Image } from 'semantic-ui-react'

class ProfileCard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      firstname: '',
      lastname: '',
      birthDay: null,
      birthMonth: null,
      birthYear: null,
      sex: null,
      affiliate: null,
      country: null,
      fetching: null,
      picture: null,
      affiliateQuery: null
    }
  }

  componentWillReceiveProps (props) {
    if (props.user && this.state.firstname === '') {
      const birthDate = new Date(props.user.age)
      this.setState({
        firstname: props.user && props.user.firstname,
        lastname: props.user && props.user.lastname,
        sex: props.user && props.user.sex,
        birthDay: birthDate.getDate(),
        birthMonth: birthDate.getMonth(),
        birthYear: birthDate.getFullYear(),
        affiliate: props.user && props.user.affiliate,
        country: props.user && props.user.country
      })
    }
  }

  setEditMode (editMode) {
    this.setState({editMode})
  }

  cancel () {
    const birthDate = new Date(this.props.user.age)
    this.setState({
      editMode: false,
      firstname: this.props.user.firstname,
      lastname: this.props.user.lastname,
      sex: this.props.user.sex,
      birthDay: birthDate.getDate(),
      birthMonth: birthDate.getMonth(),
      birthYear: birthDate.getFullYear(),
      affiliate: this.props.user.affiliate,
      country: this.props.user.country
    })
  }

  setValue (obj) {
    this.setState({ [obj.key]: obj.value })
  }

  setCountry (country) {
    this.setState({country})
  }

  async updateUser () {
    const {firstname, lastname, birthDay, birthMonth, birthYear, sex, affiliate, country} = this.state
    const age = moment(new Date(birthYear, birthMonth, birthDay)).toJSON()
    this.setState({fetching: true})
    const response = await API.updateUser({...this.props.user, firstname, lastname, age, sex, country, affiliate})
    if (response.ok) {
      notify.show(this.props.t('messages:updateOK'), 'success')
      this.setState({fetching: false, editMode: false})
      this.props.updateUser({firstname, lastname, age, sex, country, affiliate})
    } else {
      notify.show(this.props.t('messages:updateKO'), 'error')
      this.setState({fetching: false})
    }
  }

  loadAffiliates (query) {
    if (!query || query === '') {
			return Promise.resolve({ options: [] });
		}
    return API.getAffiliates(query).then(res => {
      return { options: res.data}
    })
  }

  render() {
    const {user, t} = this.props;
    const {editMode, firstname, lastname, birthMonth, birthDay, birthYear} = this.state;
    return (
      <div id="profile-card" className="mobile-card">
        {user && <div>
          <div className="mobile-card-header">
          <h3 style={{marginBottom: '2rem'}}>{t('tabs:profile')}</h3>
          <Grid columns={2}>
            <Grid.Column id="first-column">
              {user.picture && <Image centered src={user.picture} id="profile-pic" circular style={{opacity: user ? 1 : 0}}/>}
              {!user.picture && <Icon size='huge' name="user circle outline" id="avatar"/>}
            </Grid.Column>
            <Grid.Column id="second-column-profile">
              {!editMode && <div>
                <p>{user.firstname}</p>
                <p style={{marginTop: '-0.8rem'}}>{user.lastname}</p>
              </div>}
              {editMode && <div>
                <Button basic size="tiny" onClick={() => this.updateUser()}>{t('premium:subscribeModal:validate')}</Button>
                <Button basic size="tiny" color='grey' onClick={() => this.cancel()}>{t('common:cancel')}</Button>
              </div>}
            </Grid.Column>
          </Grid>
          <div id="edit-buttons"> 
            {!editMode && <Button basic size="tiny" onClick={() => this.setEditMode(true)}>{t('common:edit')}</Button>}
          </div>
        </div>
        <div className="mobile-card-content">
          {!editMode && <List inverted>
            <List.Item>
            <List.Content>
              <label>{t('profile:age')}</label>
              <p>
              {user.age ? moment().diff(user.age, 'years').toString() : '-'}
              </p>
            </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <label>{t('profile:sex')}</label>
                <p>
                  {user.sex ? t(`sex:${user.sex}`) : '-'}
                </p>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
              <label>{t('profile:affiliate')}</label>
                <p>
                  {(user.affiliate && user.affiliate.name) ? user.affiliate.name : '-'}
                </p>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
              <label>{t('profile:country')}</label>
                <p>
                  {user.country.name ? user.country.name : '-'}
                </p>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
              <label>Email</label>
                <p>
                  {user.email}
                </p>
              </List.Content>
            </List.Item>
          </List>}
          {editMode && <List inverted>
            <List.Item>
              <List.Content>
                <label>{t('profile:firstname')}</label>
                <Form.Field>
                    <Form.Input type="text" onChange={(e, data) => this.setValue({key: 'firstname', value: data.value})} value={firstname} placeholder={t('profile:firstname')} />
                </Form.Field>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <label>{t('profile:lastname')}</label>
                <Form.Field>
                    <Form.Input type="text" onChange={(e, data) => this.setValue({key: 'lastname', value: data.value})} value={lastname} placeholder={t('profile:lastname')} />
                </Form.Field>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <label>{t('profile:age')}</label>
                <Form.Field style={{display: 'flex'}}>
                  <Form.Select options={days} placeholder='-' value={birthDay} onChange={(e, data) => this.setValue({key: 'birthDay', value: data.value})} />
                  <Form.Select options={monthsSmall} placeholder='-' value={birthMonth} onChange={(e, data) => this.setValue({key: 'birthMonth', value: data.value})} />
                  <Form.Select options={years} placeholder='-' value={birthYear} onChange={(e, data) => this.setValue({key: 'birthYear', value: data.value})} />
                </Form.Field>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <label>{t('profile:sex')}</label>
                <Form.Select options={sexes.map(s => ({...s, text: t(`sex:${s.text}`)}))} placeholder={t('profile:sex')} value={this.state.sex} onChange={(e, data) => this.setValue({key: 'sex', value: data.value})} />
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <label>{t('profile:affiliate')}</label>
                <Select.Async id="affiliate-select" multi={false} placeholder={t('profile:affiliate')} value={this.state.affiliate} onChange={value => this.setValue({key: 'affiliate', value})} valueKey="id" labelKey="name" loadOptions={this.loadAffiliates.bind(this)} />
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
              <label>{t('profile:country')}</label>
              <Form.Field style={{width: '67%'}}>
                <Form.Select style={{width: '100%'}} options={countries} placeholder={t('profile:country')} value={this.state.country ? this.state.country.id : null} onChange={(e, data) => {
                  this.setCountry({id: data.value, name: data.options[data.value].text})}} />
              </Form.Field>
              </List.Content>
            </List.Item>
          </List>}
        </div>
        </div>}
      </div>
    )
  }
}
 
export default translate('translations')(ProfileCard);


// WEBPACK FOOTER //
// ./src/components/ProfileCard.js